const ROUTES = {
    HOME: "/",
    NOT_FOUND: "*",
    PAYMENT_INFORMATION: "payment-information",
    PAYMENT_SUCCESS: "payment-success/:paymentToken/:transactionTd",
};

export default ROUTES;
